import React from "react";

export function CloudPhone() {
  return (
    <svg
      width="451"
      height="459"
      viewBox="0 0 451 459"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <g id="Group">
          <g id="Group 2">
            <path
              id="Vector"
              d="M273.408 198.376H233.408C231.199 198.376 229.408 200.167 229.408 202.376C229.408 204.585 231.199 206.376 233.408 206.376H273.408C275.617 206.376 277.408 204.585 277.408 202.376C277.408 200.167 275.617 198.376 273.408 198.376Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 3">
          <g id="Group 4">
            <path
              id="Vector 2"
              d="M273.408 217.056H233.408C231.199 217.056 229.408 218.847 229.408 221.056C229.408 223.265 231.199 225.056 233.408 225.056H273.408C275.617 225.056 277.408 223.265 277.408 221.056C277.408 218.847 275.617 217.056 273.408 217.056Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 5">
          <g id="Group 6">
            <path
              id="Vector 3"
              d="M205.408 191.416H172.768C170.559 191.416 168.768 193.207 168.768 195.416V228.056C168.768 230.265 170.559 232.056 172.768 232.056H205.408C207.617 232.056 209.408 230.265 209.408 228.056V195.416C209.408 193.207 207.617 191.416 205.408 191.416ZM201.408 224.056H176.768V199.416H201.408V224.056Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 7">
          <g id="Group 8">
            <path
              id="Vector 4"
              d="M273.408 263.016H233.408C231.199 263.016 229.408 264.807 229.408 267.016C229.408 269.225 231.199 271.016 233.408 271.016H273.408C275.617 271.016 277.408 269.225 277.408 267.016C277.408 264.807 275.617 263.016 273.408 263.016Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 9">
          <g id="Group 10">
            <path
              id="Vector 5"
              d="M273.408 281.576H233.408C231.199 281.576 229.408 283.367 229.408 285.576C229.408 287.785 231.199 289.576 233.408 289.576H273.408C275.617 289.576 277.408 287.785 277.408 285.576C277.408 283.367 275.617 281.576 273.408 281.576Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 11">
          <g id="Group 12">
            <path
              id="Vector 6"
              d="M205.408 256.016H172.768C170.559 256.016 168.768 257.807 168.768 260.016V292.656C168.768 294.865 170.559 296.656 172.768 296.656H205.408C207.617 296.656 209.408 294.865 209.408 292.656V260.016C209.408 257.807 207.617 256.016 205.408 256.016ZM201.408 288.656H176.768V264.016H201.408V288.656Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 13">
          <g id="Group 14">
            <path
              id="Vector 7"
              d="M273.408 327.616H233.408C231.199 327.616 229.408 329.407 229.408 331.616C229.408 333.825 231.199 335.616 233.408 335.616H273.408C275.617 335.616 277.408 333.825 277.408 331.616C277.408 329.407 275.617 327.616 273.408 327.616Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 15">
          <g id="Group 16">
            <path
              id="Vector 8"
              d="M253.408 346.296H233.408C231.199 346.296 229.408 348.087 229.408 350.296C229.408 352.505 231.199 354.296 233.408 354.296H253.408C255.617 354.296 257.408 352.505 257.408 350.296C257.408 348.087 255.617 346.296 253.408 346.296Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 17">
          <g id="Group 18">
            <path
              id="Vector 9"
              d="M205.408 320.616H172.768C170.559 320.616 168.768 322.407 168.768 324.616V357.296C168.768 359.505 170.559 361.296 172.768 361.296H205.408C207.617 361.296 209.408 359.505 209.408 357.296V324.616C209.408 322.407 207.617 320.616 205.408 320.616ZM201.408 353.296H176.768V328.616H201.408V353.296Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 19">
          <g id="Group 20">
            <path
              id="Vector 10"
              d="M240.728 426.376C240.706 417.931 233.853 411.096 225.408 411.096C216.947 411.096 210.088 417.955 210.088 426.416C210.088 434.877 216.947 441.736 225.408 441.736C233.869 441.736 240.728 434.877 240.728 426.416C240.728 426.403 240.728 426.389 240.728 426.376ZM225.408 433.576C221.365 433.576 218.088 430.299 218.088 426.256C218.088 422.213 221.365 418.936 225.408 418.936C229.451 418.936 232.728 422.213 232.728 426.256C232.728 430.299 229.451 433.576 225.408 433.576Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 21">
          <g id="Group 22">
            <path
              id="Vector 11"
              d="M292.168 149.576H158.648C156.439 149.576 154.648 151.367 154.648 153.576C154.648 155.785 156.439 157.576 158.648 157.576H292.168C294.377 157.576 296.168 155.785 296.168 153.576C296.168 151.367 294.377 149.576 292.168 149.576Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 23">
          <g id="Group 24">
            <path
              id="Vector 12"
              d="M292.168 396.936H158.648C156.439 396.936 154.648 398.727 154.648 400.936C154.648 403.145 156.439 404.936 158.648 404.936H292.168C294.377 404.936 296.168 403.145 296.168 400.936C296.168 398.727 294.377 396.936 292.168 396.936Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 25">
          <g id="Group 26">
            <path
              id="Vector 13"
              d="M232.368 128.456H218.448C216.239 128.456 214.448 130.247 214.448 132.456C214.448 134.665 216.239 136.456 218.448 136.456H232.368C234.577 136.456 236.368 134.665 236.368 132.456C236.368 130.247 234.577 128.456 232.368 128.456Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 27">
          <g id="Group 28">
            <path
              id="Vector 14"
              d="M131.488 58.816C129.869 57.313 127.338 57.407 125.835 59.027C125.826 59.037 125.817 59.047 125.808 59.056C115.023 70.927 107.583 85.448 104.248 101.136C103.75 103.288 105.091 105.437 107.243 105.935C107.245 105.935 107.246 105.936 107.248 105.936H108.088C110.007 105.979 111.685 104.653 112.088 102.776C115.121 88.487 121.899 75.262 131.728 64.456C133.215 62.831 133.107 60.309 131.488 58.816Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 29">
          <g id="Group 30">
            <path
              id="Vector 15"
              d="M167.568 37.216C166.828 35.128 164.536 34.036 162.448 34.776C158.153 36.294 153.981 38.139 149.968 40.296C148.024 41.345 147.299 43.772 148.348 45.716C149.043 47.003 150.385 47.809 151.848 47.816C152.505 47.813 153.15 47.648 153.728 47.336C157.392 45.376 161.204 43.704 165.128 42.336C167.216 41.596 168.308 39.304 167.568 37.216Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 31">
          <g id="Group 32">
            <path
              id="Vector 16"
              d="M400.888 189.736C398.679 189.736 396.888 191.527 396.888 193.736C396.881 196.41 396.721 199.081 396.408 201.736C396.037 203.914 397.502 205.98 399.679 206.351C399.735 206.361 399.791 206.369 399.848 206.376H400.328C402.349 206.393 404.065 204.9 404.328 202.896C404.714 199.858 404.901 196.798 404.888 193.736C404.888 191.527 403.097 189.736 400.888 189.736Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 33">
          <g id="Group 34">
            <path
              id="Vector 17"
              d="M397.375 215.979C397.373 215.978 397.371 215.977 397.368 215.976C395.316 215.157 392.989 216.157 392.171 218.209C392.17 218.211 392.169 218.213 392.168 218.216C387.256 230.517 378.753 241.055 367.768 248.456C365.956 249.72 365.513 252.214 366.777 254.025C367.515 255.083 368.718 255.72 370.008 255.736C370.806 255.738 371.586 255.501 372.248 255.056C384.558 246.761 394.09 234.957 399.608 221.176C400.427 219.124 399.427 216.797 397.375 215.979Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 35">
          <g id="Group 36">
            <path
              id="Vector 18"
              d="M360.808 109.576C353.893 70.2829 316.435 44.0339 277.141 50.9489C275.512 51.2359 273.893 51.5779 272.288 51.9759C241.537 1.0989 175.365 -15.2151 124.488 15.5359C92.1868 35.0589 72.4718 70.0739 72.5278 107.816C72.5278 109.016 72.5278 110.216 72.5278 111.456C34.0268 121.886 7.22081 156.728 7.00781 196.616C7.05181 245.231 46.3928 284.662 95.0078 284.816H133.728V436.816C133.728 449.055 143.649 458.976 155.888 458.976H294.768C307.007 458.976 316.928 449.055 316.928 436.816V284.816H346.728C395.302 286.423 435.982 248.348 437.589 199.773C439.09 154.404 405.835 115.338 360.808 109.576ZM308.928 436.856C308.906 444.667 302.579 450.994 294.768 451.016H156.048C148.237 450.994 141.91 444.667 141.888 436.856V132.096C141.91 124.285 148.237 117.958 156.048 117.936H294.768C302.579 117.958 308.906 124.285 308.928 132.096V436.856ZM429.682 203.591C426.01 246.19 389.491 278.371 346.768 276.656H316.928V132.096C316.906 119.866 306.997 109.958 294.768 109.936H156.048C143.819 109.958 133.91 119.866 133.888 132.096V276.816H95.1678C50.9928 277.628 14.5228 242.475 13.7108 198.3C13.0028 159.757 39.8818 126.19 77.6478 118.456C79.5088 118.037 80.8148 116.363 80.7678 114.456C80.6078 112.296 80.5278 110.136 80.5278 107.976C80.4108 52.9459 124.927 8.2419 179.956 8.1249C215.939 8.0489 249.167 27.3789 266.888 58.6959C267.799 60.3149 269.704 61.0929 271.488 60.5759C277.306 58.8509 283.34 57.9619 289.408 57.9359C321.626 57.9409 348.922 81.6709 353.408 113.576C353.645 115.368 355.056 116.779 356.848 117.016C400.868 120.811 433.476 159.572 429.682 203.591Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 37">
          <g id="Group 38">
            <path
              id="Vector 19"
              d="M108.008 324.136H36.0081C16.5901 324.136 0.848145 339.878 0.848145 359.296C0.848145 378.714 16.5901 394.456 36.0081 394.456H53.0881L42.9281 404.616C41.3601 406.172 41.3491 408.704 42.9051 410.273C42.9131 410.281 42.9201 410.289 42.9281 410.296C43.6831 411.045 44.7051 411.462 45.7681 411.456C46.8171 411.452 47.8231 411.035 48.5681 410.296L65.4081 393.296C65.7951 392.926 66.0951 392.475 66.2881 391.976C66.6881 391.002 66.6881 389.91 66.2881 388.936C66.0951 388.437 65.7951 387.986 65.4081 387.616L48.4081 370.616C46.8481 369.065 44.3281 369.065 42.7681 370.616C41.2001 372.172 41.1891 374.704 42.7451 376.273C42.7531 376.281 42.7601 376.289 42.7681 376.296L52.9281 386.456H36.0081C21.0081 386.456 8.8481 374.296 8.8481 359.296C8.8481 344.296 21.0081 332.136 36.0081 332.136H108.008C110.217 332.136 112.008 330.345 112.008 328.136C112.008 325.927 110.217 324.136 108.008 324.136Z"
              fill="#BA0572"
            />
          </g>
        </g>
        <g id="Group 39">
          <g id="Group 40">
            <path
              id="Vector 20"
              d="M414.968 365.136H414.808H397.728L407.888 354.976C409.439 353.416 409.439 350.896 407.888 349.336C406.328 347.785 403.808 347.785 402.248 349.336L385.408 366.296C384.259 367.437 383.912 369.159 384.528 370.656C384.71 371.161 385.012 371.614 385.408 371.976L402.408 388.976C403.153 389.715 404.159 390.132 405.208 390.136C406.271 390.142 407.293 389.725 408.048 388.976C409.599 387.416 409.599 384.896 408.048 383.336L397.888 373.136H414.968C429.968 373.136 442.128 385.296 442.128 400.296C442.128 415.296 429.968 427.456 414.968 427.456H342.968C340.759 427.456 338.968 429.247 338.968 431.456C338.968 433.665 340.759 435.456 342.968 435.456H414.968C434.386 435.456 450.128 419.714 450.128 400.296C450.128 380.878 434.386 365.136 414.968 365.136Z"
              fill="#BA0572"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
